
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RejectionItemsGrid extends Serenity.EntityGrid<RejectionItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.RejectionItems'; }
        protected getDialogType() { return RejectionItemsDialog; }
        protected getIdProperty() { return RejectionItemsRow.idProperty; }
        protected getInsertPermission() { return RejectionItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return RejectionItemsRow.localTextPrefix; }
        protected getService() { return RejectionItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}